// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_j7-1";
export var rowFirst = "_j7-3";
export var rowLast = "_j7-5";
export var rowMiddle = "_j7-4";
export var ticketListScroll = "_j7-2";
export var ticketStack = "_j7-0";